import { useRef } from 'react'
import { FocusRing } from '@react-aria/focus'
import cx from 'classnames'
import Styles from './ListCollapseToggleV2.module.scss'
import { pluralize } from 'utils'
import { useCollabItemContext } from '../CollabItem'
import { ReactComponent as ChevronDown } from 'assets/icons/chevronDown.svg'
import { Counter, CounterSize, CounterVariant } from 'components/Counter/Counter'

interface Props {
  count: number
  onToggle: () => void
  collapsed: boolean
  unreadCount: number
  itemId: number | string
}

const ListCollapseToggleV2 = ({ count, unreadCount, collapsed, onToggle, itemId }: Props) => {
  const { isHighlighted, editing } = useCollabItemContext()
  const ref = useRef<HTMLDivElement | null>(null)
  const collapsibleItemsCount = count - 1
  const isEditing = editing?.id === itemId

  if (collapsibleItemsCount <= 0) return null

  return (
    <FocusRing focusRingClass={Styles.focus}>
      <div
        className={cx(Styles.toggleContainer, {
          [Styles.highlighted]: isHighlighted,
          [Styles.collapsed]: collapsed,
          [Styles.isEditing]: isEditing,
        })}
        ref={ref}
      >
        <div className={Styles.toggle} />
        <div className={cx(Styles.labelContainer, { [Styles.unread]: unreadCount > 0 })} onClick={onToggle}>
          <span className={Styles.label}>
            {collapsed ? (
              <>{`${collapsibleItemsCount} ${pluralize('reply', collapsibleItemsCount)}`}</>
            ) : (
              <>{`Hide ${pluralize('reply', collapsibleItemsCount)}`}</>
            )}
            {unreadCount > 0 && (
              <Counter variant={CounterVariant.Primary} size={CounterSize.xs} count={unreadCount} noBorder />
            )}
          </span>
          {<ChevronDown className={cx(Styles.chevron, { [Styles.rotate]: collapsed })} />}
        </div>
      </div>
    </FocusRing>
  )
}

export { ListCollapseToggleV2 }
